import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faBars } from "@fortawesome/free-solid-svg-icons";
import { Facebook, Instagram, Twitter } from "lucide-react";
import Bike2 from "../../../assets/Images/bike2.png";
import Footer from "../Footer";
import Slider from "react-slick";
import wlogo from "../../../assets/Images/TCL_logo (1).png";
import wha from "../../../assets/Images/wha.jpg";
import "./BikePackage.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from "react-router-dom";

const HotelPackage = () => {
  const [bikePackages, setBikePackages] = useState([]);
  const [hotelPackages, setHotelPackages] = useState([]);
  const [isToggled, setIsToggled] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(
    sessionStorage.getItem("isLoggedIn") === "true"
  );

  const navigate = useNavigate();

  useEffect(() => {
    const fetchPackages = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}AllPackages`);
        const result = await response.json();
        const allPackages = result?.data || [];

        const filteredBikes = allPackages.filter(pkg =>
          pkg?.category?.name?.includes("Hotels")
        );
        setBikePackages(filteredBikes || []);

        const filteredHotels = allPackages.filter(
          pkg => pkg?.category?.name?.toLowerCase() === "hotels"
        );
        console.log("Hotel", filteredHotels);
        setHotelPackages(filteredHotels);
      } catch (error) {
        console.error("Error fetching packages:", error);
      }
    };

    fetchPackages();
  }, []);

  const handleToggle = () => {
    setIsToggled(!isToggled);
  };

  const closeNavbar = () => {
    setIsToggled(false);
  };

  const handleLogOut = () => {
    alert("You are Logging out...");
    sessionStorage.removeItem("isLoggedIn");
    sessionStorage.removeItem("token");
    setIsLoggedIn(false);
    setIsToggled(false);
    setTimeout(() => {
      navigate("/");
    }, 1500);
  };

  return (
    <div className="container-fluid p-0">
      {/* --- START CUSTOM NAVBAR (with black text) --- */}
      {/* <nav className="navbar navbar-expand-lg p-0">
        <div className="container px-4 d-flex">
          <div className="w-100 d-flex justify-content-between">
            <NavLink to="/" className="navbar-brand fw-bold text-dark" onClick={closeNavbar}>
              <img src={wlogo} className="d-none d-md-block" width="120" alt="" />
              <img src={wlogo} className="d-block d-md-none" width="120" alt="" />
            </NavLink>
            <button
              className="navbar-toggler text-dark"
              type="button"
              onClick={handleToggle}
              tabIndex="-1"
            >
              <FontAwesomeIcon icon={faBars} />
            </button>
          </div>

          <div className={`collapse navbar-collapse ${isToggled ? "show" : ""}`}>
            <ul className="navbar-nav ml-auto gap-4">
              <li className="nav-item fw-semibold">
                <NavLink to="/" exact className="nav-link text-dark" onClick={closeNavbar}>
                  Home
                </NavLink>
              </li>
              <li className="nav-item fw-semibold">
                <NavLink
                  to="/BikePackage"
                  exact
                  className="nav-link text-dark"
                  onClick={closeNavbar}
                  style={{ width: "max-content" }}
                >
                  Bike Package
                </NavLink>
              </li>
              <li className="nav-item fw-semibold">
                <NavLink
                  to="/CarPackage"
                  exact
                  className="nav-link text-dark"
                  onClick={closeNavbar}
                  style={{ width: "max-content" }}
                >
                  Car Package
                </NavLink>
              </li>
              <li className="nav-item fw-semibold">
                <a
                  href="https://travellerchoiceladakh.com/blog/"
                  className="nav-link text-dark"
                  onClick={closeNavbar}
                >
                  Blog
                </a>
              </li>
              <li className="nav-item fw-semibold">
                <NavLink
                  to="/contact-us"
                  exact
                  className="nav-link text-dark"
                  onClick={closeNavbar}
                  style={{ width: "max-content" }}
                >
                  Contact Us
                </NavLink>
              </li>

              {!isLoggedIn ? (
                <li className="nav-item fw-semibold">
                  <NavLink
                    to="/login"
                    exact
                    className="nav-link text-dark"
                    onClick={closeNavbar}
                    style={{ width: "max-content" }}
                  >
                    Log In
                  </NavLink>
                </li>
              ) : (
                <li className="nav-item dropdown">
                  <button
                    className="nav-link dropdown-toggle text-dark"
                    id="userDropdown"
                    role="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    onClick={handleToggle}
                  >
                    <FontAwesomeIcon icon={faUser} />
                  </button>

                  <div
                    className={`dropdown-menu ${isToggled ? "show" : ""}`}
                    aria-labelledby="userDropdown"
                  >
                    <NavLink to="/profilepage1" className="dropdown-item" onClick={closeNavbar}>
                      Profile
                    </NavLink>
                    <button className="dropdown-item" onClick={() => { handleLogOut(); closeNavbar(); }}>
                      Log Out
                    </button>
                  </div>
                </li>
              )}
            </ul>
          </div>
        </div>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://api.whatsapp.com/send?phone=+919149516495&text=Hi there! 👋 How can we assist you today? Feel free to ask any questions or get help with your concerns."
          className="whatsapp_btn"
        >
          <img src={wha} alt="whatsapp" className="w-100" />
        </a>
      </nav> */}
      <nav className="navbar navbar-expand-lg p-0 custom-navbar">
  <div className="container px-4 d-flex">
    <div className="w-100 d-flex justify-content-between">
      <NavLink to="/" className="navbar-brand fw-bold" onClick={closeNavbar}>
        <img src={wlogo} className="d-none d-md-block" width="120" alt="" />
        <img src={wlogo} className="d-block d-md-none" width="120" alt="" />
      </NavLink>

      <button
        className="navbar-toggler"
        type="button"
        onClick={handleToggle}
        tabIndex="-1"
      >
        <FontAwesomeIcon icon={faBars} />
      </button>
    </div>

    <div className={`collapse navbar-collapse ${isToggled ? "show" : ""}`}>
      <ul className="navbar-nav ml-auto gap-4">
        <li className="nav-item fw-semibold">
          <NavLink to="/" exact className="nav-link" onClick={closeNavbar}>
            Home
          </NavLink>
        </li>
        <li className="nav-item fw-semibold">
          <NavLink to="/BikePackage" exact className="nav-link" onClick={closeNavbar} style={{ width: "max-content" }}>
            Bike Package
          </NavLink>
        </li>
        <li className="nav-item fw-semibold">
          <NavLink to="/CarPackage" exact className="nav-link" onClick={closeNavbar} style={{ width: "max-content" }}>
            Car Package
          </NavLink>
        </li>
        <li className="nav-item fw-semibold">
          <a href="https://travellerchoiceladakh.com/blog/" className="nav-link" onClick={closeNavbar}>
            Blog
          </a>
        </li>
        <li className="nav-item fw-semibold">
          <NavLink to="/contact-us" exact className="nav-link" onClick={closeNavbar} style={{ width: "max-content" }}>
            Contact Us
          </NavLink>
        </li>

        {!isLoggedIn ? (
          <li className="nav-item fw-semibold">
            <NavLink to="/login" exact className="nav-link" onClick={closeNavbar} style={{ width: "max-content" }}>
              Log In
            </NavLink>
          </li>
        ) : (
          <li className="nav-item dropdown">
            <button
              className="nav-link dropdown-toggle"
              id="userDropdown"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              onClick={handleToggle}
            >
              <FontAwesomeIcon icon={faUser} />
            </button>

            <div className={`dropdown-menu ${isToggled ? "show" : ""}`} aria-labelledby="userDropdown">
              <NavLink to="/profilepage1" className="dropdown-item" onClick={closeNavbar}>
                Profile
              </NavLink>
              <button className="dropdown-item" onClick={() => { handleLogOut(); closeNavbar(); }}>
                Log Out
              </button>
            </div>
          </li>
        )}
      </ul>
    </div>
  </div>

  <a
    target="_blank"
    rel="noopener noreferrer"
    href="https://api.whatsapp.com/send?phone=+919149516495&text=Hi there! 👋 How can we assist you today? Feel free to ask any questions or get help with your concerns."
    className="whatsapp_btn"
  >
    <img src={wha} alt="whatsapp" className="w-100" />
  </a>
</nav>

      {/* --- END CUSTOM NAVBAR --- */}

      <div className="container py-5 mt-5">
        <div className="row d-flex my-5">
          <h2
            className="col-md-4 fw-bold"
            style={{
              fontSize: "2rem",
              fontWeight: "700",
              textTransform: "uppercase",
              letterSpacing: "1px",
            }}
          >
            Explore Resorts
          </h2>
          <p className="col-md-8 text-center ">Ride through Ladakh’s summer bliss - blooming valleys, clear skies, and cultural wonders. A perfect blend of adventure, beauty, and serenity on every winding turn.</p>
        </div>

        <div className="row mt-3">
          {hotelPackages.map((hotel, index) => (
            <div key={index} className="col-md-3 p-2 mb-4">
              <div className="card h-100 border-0">
                <div style={{ position: "relative" }}>
                  <img
                    src={hotel.image?.[0] || "https://via.placeholder.com/300"}
                    className="card-img-top"
                    alt={hotel.name}
                    style={{ height: "200px", objectFit: "cover", borderRadius: "15px" }}
                  />
                  {/* <Link
                    to={`/DetailHotelPackage/${hotel.id}`}
                    style={{
                      position: "absolute",
                      bottom: "10px",
                      right: "10px",
                      fontSize: "15px",
                      color: "#fff",
                      textDecoration: "none"
                    }}
                  >
                    View Details
                  </Link> */}
                </div>
                <div className="card-body">
                <Link
  to={`/DetailHotelPackage/${hotel.id}`}
  style={{ textDecoration: "none", color: "inherit" }}
>
  <h5 className="card-title">{hotel.name}</h5>
  <p className="card-text text-muted">{hotel.location}</p>
</Link>
                  {/* <h5 className="card-title">{hotel.name}</h5>
                  <p className="card-text text-muted">{hotel.location}</p> */}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default HotelPackage;
